import React from "react"
import { MyCardHelpers } from "@macashipo/mlib"

const MC_card_quote_part = React.lazy(() => import("./Types/card_quote_part"))
const List = {
  card_quote_part: MC_card_quote_part,
}
const MyLibOne = {
  init() {
    MyCardHelpers.addTypesFromListLazy(List)
  },
}

export default MyLibOne
